import * as R from 'ramda';
import { fromJS } from 'immutable';
import * as abstractSubdivisionsActions from '../actions/abstractSubdivision';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  abstractSubdivision: { data: {}, state: null },
  abstractSubdivisionDetail: { data: {}, state: null },
  abstractSubdivisionDetailFiles: {},
  abstractSubdivisionDetails: { data: [], state: null },
  abstractSubdivisionIndicators: { data: [], state: null },
  abstractSubdivisionFiles: {},
  abstractSubdivisionPlat: { data: {}, state: null },
  abstractSubdivisionPlatFiles: {},
  abstractSubdivisionPlats: { data: [], state: null },
  abstractSubdivisionPlatTypes: { data: [], state: null },
  abstractSubdivisions: {
    data: [],
    total: 0,
    state: null,
    updateState: null,
    sortModel: [],
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISIONS[START]:
      return state.setIn(
        ['abstractSubdivisions', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISIONS[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivisions', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['abstractSubdivisions', 'total'],
          fromJS(
            R.pathOr(
              [],
              ['data', 'totalAbstractSubdivision', 'abstractSubdivisionCount'],
              action,
            ),
          ),
        )
        .setIn(['abstractSubdivisions', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISIONS[ERROR]:
      return state.setIn(
        ['abstractSubdivisions', 'state'],
        fetchingState.ERROR,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_INDICATORS[
      START
    ]:
      return state.setIn(
        ['abstractSubdivisionIndicators', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_INDICATORS[
      SUCCESS
    ]:
      return state
        .setIn(
          ['abstractSubdivisionIndicators', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(
          ['abstractSubdivisionIndicators', 'state'],
          fetchingState.LOADED,
        );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_INDICATORS[
      ERROR
    ]:
      return state.setIn(
        ['abstractSubdivisionIndicators', 'state'],
        fetchingState.ERROR,
      );
    case abstractSubdivisionsActions.RESET_ABSTRACT_SUBDIVISIONS:
      return state
        .setIn(['abstractSubdivisions', 'data'], fromJS([]))
        .setIn(['abstractSubdivisions', 'total'], fromJS(0));

    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[
      START
    ]:
      return state.setIn(
        ['abstractSubdivisions', 'updateState'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[
      SUCCESS
    ]:
      return state.setIn(
        ['abstractSubdivisions', 'updateState'],
        fetchingState.LOADED,
      );
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DESCRIPTION[
      ERROR
    ]:
      return state.setIn(
        ['abstractSubdivisions', 'updateState'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION[START]:
      return state.setIn(
        ['abstractSubdivision', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivision', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivision', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION[ERROR]:
      return state.setIn(['abstractSubdivision', 'state'], fetchingState.ERROR);
    case abstractSubdivisionsActions.RESET_ABSTRACT_SUBDIVISION:
      return state
        .setIn(['abstractSubdivision', 'data'], fromJS({}))
        .setIn(['abstractSubdivision', 'state'], null);

    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION[START]:
      return state.setIn(
        ['abstractSubdivision', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivision', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivision', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION[ERROR]:
      return state.setIn(['abstractSubdivision', 'state'], fetchingState.ERROR);

    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION[SUCCESS]:
      const abstractSubdivisions = state
        .getIn(['abstractSubdivisions', 'data'])
        .toJS()
        .filter(as => as.abstractSubdivision !== action.asCode);
      const total = state.getIn(['abstractSubdivisions', 'total']) - 1;

      return state
        .setIn(['abstractSubdivisions', 'data'], fromJS(abstractSubdivisions))
        .setIn(['abstractSubdivisions', 'total'], total);

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLATS[START]:
      return state.setIn(
        ['abstractSubdivisionPlats', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLATS[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivisionPlats', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['abstractSubdivisionPlats', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLATS[ERROR]:
      return state.setIn(
        ['abstractSubdivisionPlats', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_FILE[START]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_FILE[ERROR]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_FILE[START]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_FILE[ERROR]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.ERROR,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_FILE[START]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_FILE[ERROR]: {
      return state.setIn(
        ['abstractSubdivisionFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAILS[START]:
      return state.setIn(
        ['abstractSubdivisionDetails', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAILS[
      SUCCESS
    ]:
      return state
        .setIn(
          ['abstractSubdivisionDetails', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['abstractSubdivisionDetails', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAILS[ERROR]:
      return state.setIn(
        ['abstractSubdivisionDetails', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAIL[START]:
      return state.setIn(
        ['abstractSubdivisionDetail', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAIL[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivisionDetail', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivisionDetail', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_DETAIL[ERROR]:
      return state.setIn(
        ['abstractSubdivisionDetail', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL[START]:
      return state.setIn(
        ['abstractSubdivisionDetail', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL[
      SUCCESS
    ]:
      return state
        .setIn(
          ['abstractSubdivisionDetail', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivisionDetail', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL[ERROR]:
      return state.setIn(
        ['abstractSubdivisionDetail', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[
      START
    ]:
      return state.setIn(
        ['abstractSubdivisionPlatTypes', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[
      SUCCESS
    ]:
      return state
        .setIn(
          ['abstractSubdivisionPlatTypes', 'data'],
          fromJS(R.pathOr([], ['data', 'results'], action)),
        )
        .setIn(['abstractSubdivisionPlatTypes', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT_TYPES[
      ERROR
    ]:
      return state.setIn(
        ['abstractSubdivisionPlatTypes', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_DETAIL_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionDetailFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT[START]:
      return state.setIn(
        ['abstractSubdivisionPlat', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivisionPlat', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivisionPlat', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.FETCH_ABSTRACT_SUBDIVISION_PLAT[ERROR]:
      return state.setIn(
        ['abstractSubdivisionPlat', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT[START]:
      return state.setIn(
        ['abstractSubdivisionPlat', 'state'],
        fetchingState.FETCHING,
      );
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT[SUCCESS]:
      return state
        .setIn(
          ['abstractSubdivisionPlat', 'data'],
          fromJS(R.pathOr([{}], ['data', 'results'], action)[0]),
        )
        .setIn(['abstractSubdivisionPlat', 'state'], fetchingState.LOADED);
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT[ERROR]:
      return state.setIn(
        ['abstractSubdivisionPlat', 'state'],
        fetchingState.ERROR,
      );

    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.INSERT_ABSTRACT_SUBDIVISION_PLAT_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.DELETE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.ERROR,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      START
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.FETCHING,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      SUCCESS
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.LOADED,
      );
    }
    case abstractSubdivisionsActions.UPDATE_ABSTRACT_SUBDIVISION_PLAT_FILE[
      ERROR
    ]: {
      return state.setIn(
        ['abstractSubdivisionPlatFiles', 'state'],
        fetchingState.ERROR,
      );
    }

    case abstractSubdivisionsActions.CHANGE_SORT_MODEL: {
      return state.setIn(
        ['abstractSubdivisions', 'sortModel'],
        fromJS(action.payload),
      );
    }

    default:
      return state;
  }
};
